"use client";
import { motion } from "framer-motion";
import { Box } from "@mui/material";
import * as React from "react";

export function LettersPullUp({
	text,
	className = "",
	pullUpDelay = 0.05,
}: {
	text: string;
	className?: string;
	pullUpDelay?: number;
}) {
	const splittedText = text.split("");

	const pullUpVariant = {
		initial: {
			y: 10,
			opacity: 0,
		},
		animate: (i: number) => ({
			y: 0,
			opacity: 1,
			transition: {
				delay: i * pullUpDelay,
			},
		}),
	};

	const ref = React.useRef(null);
	// const isInView =

	return (
		<Box
			style={{
				display: "flex",
				justifyContent: "start",
				flexWrap: "wrap",
				alignItems: "flex-start",
			}}
		>
			{splittedText.map((current, i) => {
				if (current === "\n") {
					return <br key={i} />;
				}
				return (
					<motion.div
						key={i}
						ref={ref}
						variants={pullUpVariant}
						initial="initial"
						animate="animate"
						custom={i}
						className={className}
						style={{ display: current === " " ? "inline-block" : "inline" }}
					>
						{current === " " ? <span>&nbsp;</span> : current}
					</motion.div>
				);
			})}
		</Box>
	);
}
